export const log = (...args) => {
	// console.log(...args)
}

export default log
